import { toSentenceCase, updateCategoryType } from '@/plugins/dataLayer/utils/index.js';

export default function($store) {
  return {
    name: 'customizer',
    event: {
      name: 'trackEvent',
      nameIframe: 'loadEventData',
      category: 'Customs',
      customMetrics: {},
      customVariables: {},
      _clear: true,
      nonInteractive: false
    },
    types: {
      customizerBuyPanel: 'Add to Cart Flyout',
      customizerCreateYourOwn: 'Customizer - Create your own',
      customizerIntroVideo: 'UGC Flow - Video - Customizer',
      customizerRotateModel: 'Customizer - Rotate Picture',
      customizerShareDesign: 'Customizer - Share Design',
      customizerSplashPage: 'Customizer - Splash Page',
      customizerSubMenu: "Customizer - Sub Menu",
      customizerSwatches: "Customizer - Select: ",
      customizerTopHeader: 'Customizer - Top Nav',
      customizerTransferDesign: 'Customizer - Change Style',
      customizerTransferDesignSelectStyle: 'Customizer - Change Style - Select Style',
      selectComponentArrow: 'Customizer - Select Shoe Component: Arrows',
      selectComponentMenu: 'Customizer - Select Shoe Component: Menu',
      selectFlyouttMenu: 'Customizer - Select Component: Fly Out',
      selectComponentVisual: 'Select Shoe Component: Picture',
      customizerPickYourOwnColor: 'Customizer - Pick Your Own Color',
      customizerQuickAdjust: 'Customizer - Sub Menu',
      customizerDoneAdjust: 'Customizer - Graphic Editor',
      customizerUgcFlow: 'UGC Flow'
    },
    /**
     * @function logAnalyticsEvent
     * @description Adds an event to GTM's dataLayer.
     * These events are during the component selection workflow of Customizer
     * but share the same formatting. This function is provided for the Customizer
     * in order to avoid code duplication in the formatting of the GTM events.
     *
     * @param {object} payload
     * MUST have model attribute, to assure the dataLayer event name.
     * MUST have component attribute for next event, to assure the dataLayer eventLabel.
     * MUST have type attribute for next event, to assure the dataLayer eventAction.
     * @returns {void}
     */
    logAnalyticsEvent: function (payload) {
      let validEvent = true;
      const { forceEcomDataLayerFormat = false } = payload;

      const useEcomDataLayerFormat = $store.getters['utils/useEcomDataLayerFormat'] || forceEcomDataLayerFormat;
      const canvasActive = $store.getters["utils/canvasActive"];
      const data = {
        event: useEcomDataLayerFormat ? this.event.nameIframe : this.event.name,
        eventCategory: this.event.category,
        eventLabel: payload.component,
        eventAction: payload.type
      };

      if (useEcomDataLayerFormat) {
        data.nonInteractive = this.event.nonInteractive;
        data.customMetrics = payload.customMetrics ? payload.customMetrics : this.event.customMetrics;
        data.customVariables = payload.customMetrics ? payload.customMetrics : this.event.customVariables;
        data._clear = this.event._clear;
      }

      switch (payload.type) {
        case this.types.selectComponentMenu:
        case this.types.selectFlyouttMenu:
        case this.types.selectComponentArrow:
        case this.types.selectComponentVisual:
          data.eventLabel = toSentenceCase(payload.componentName.replace('_', ' '));
          break;
        case this.types.customizerSubMenu:
          data.eventLabel = toSentenceCase(payload.eventLabel.replace(/[-_]/g,' '));
          break;
        case this.types.customizerTopHeader:
        case this.types.customizerCreateYourOwn:
        case this.types.customizerSplashPage:
        case this.types.customizerTransferDesign:
        case this.types.customizerPickYourOwnColor:
        case this.types.customizerQuickAdjust:
        case this.types.customizerDoneAdjust:
        case this.types.customizerTransferDesignSelectStyle:
        case this.types.customizerUgcFlow:
          data.eventLabel = payload.eventLabel;
          break;
        case this.types.customizerSwatches:
          data.eventLabel = payload.eventLabel;
          data.eventAction = this.types.customizerSwatches + toSentenceCase(payload.swatchGroup);
          break;
        case this.types.customizerShareDesign:
          data.eventLabel = payload.eventLabel;
          if (useEcomDataLayerFormat) {
            if (data.eventLabel === 'Send to e-mail') {
              data.customMetrics = { elementConversion: 1 }
            } else if (data.eventLabel === 'Close Modal') {
              data.customMetrics = { elementClose: 1 }
            }
          }
          break;
        case this.types.customizerRotateModel:
          data.eventLabel = "";
          break;
        case this.types.customizerIntroVideo:
          data.eventLabel = payload.eventLabel;
          break;
        case this.types.customizerBuyPanel:
          data.eventLabel = payload.eventLabel;
          data.preCreatedCustomCode = $store.state.utils.queryParams.preCreatedCustomCode || null;
          data.styleCode = $store.state.utils.queryParams.styleCode || null;
          data.recipeId = $store.state.utils.queryParams.recipe ?? $store.state.recipe.recipe_v2.recipe_id;
          if (payload.subtype) {
            data.eventAction = `${ this.types.customizerBuyPanel } - ${ payload.subtype }`;
          }
          break;
        default:
          validEvent = false;
      }
      if (validEvent) {
        try {
          if(canvasActive) parent.dataLayer.push(data);
          else dataLayer.push(data)
        } catch (err) {
          console.error("CORS origin error on datalayer push to parent", err);
        }
      } else {
        console.warn('Customizer: invalid data layer event: ', data);
      }
    },
    updateCategoryType: updateCategoryType,
  };
};
